export const GUIDE_ONBOARDING_STEPS = [
  {
    id: "property",
    label: "Property",
    group: "Getting started",
    section: "home",
  },
  {
    id: "branding",
    label: "Branding",
    group: "Getting started",
    section: "layout",
  },
  {
    id: "layout",
    label: "Layout",
    group: "Getting started",
    section: "layout",
  },
  {
    id: "your-stay",
    label: "Your Stay",
    group: "Home guide",
    section: "home",
    tabType: "arrival",
  },
  {
    id: "about-home",
    label: "About Your Home",
    group: "Home guide",
    section: "home",
    tabType: "about",
  },
  {
    id: "departure",
    label: "Departure",
    group: "Home guide",
    section: "home",
    tabType: "departure",
  },
  {
    id: "rental-rules",
    label: "Rental Rules",
    group: "Home guide",
    section: "home",
    tabType: "rules",
  },
  {
    id: "safety",
    label: "Safety Information",
    group: "Home guide",
    section: "home",
    tabType: "safety",
  },
  {
    id: "add-home-section",
    label: "Add More",
    group: "Home guide",
    section: "home",
    optional: true,
  },
  {
    id: "grocery-pharmacy",
    label: "Grocery & Pharmacy",
    group: "Area guide",
    section: "area",
    categoryType: "essentials",
    optional: true,
  },
  {
    id: "restaurants",
    label: "Restaurants",
    group: "Area guide",
    section: "area",
    categoryType: "restaurants",
    optional: true,
  },
  {
    id: "things-to-do",
    label: "Things to Do",
    group: "Area guide",
    section: "area",
    categoryType: "attractions",
    optional: true,
  },
  {
    id: "add-area-section",
    label: "Add More",
    group: "Area guide",
    section: "area",
    optional: true,
  },
  {
    id: "preview-publish",
    label: "Preview & Publish",
    group: "Launch",
    section: "layout",
  },
  {
    id: "first-booking",
    label: "Add First Booking",
    group: "Launch",
    section: "guestbook",
  },
  {
    id: "send",
    label: "Send",
    group: "Launch",
    section: "guestbook",
  },
];

const STEP_ALIASES = {
  area: "grocery-pharmacy",
};

export const getGuideOnboardingStep = (stepId) =>
  GUIDE_ONBOARDING_STEPS.find(
    (step) => step.id === (STEP_ALIASES[stepId] || stepId),
  ) ||
  GUIDE_ONBOARDING_STEPS[0];

export const getGuideOnboardingStepIndex = (stepId) =>
  GUIDE_ONBOARDING_STEPS.findIndex(
    (step) => step.id === (STEP_ALIASES[stepId] || stepId),
  );
